// SimplePractice booking / client portal entry points.
//
// The booking links are NOT in this bundle any more. They used to be, and that
// was the hole: a bot could read them straight out of the page source and post
// to SimplePractice without ever meeting a check on our side. They now live in
// the backend and are only returned after the visitor passes Cloudflare
// Turnstile (agreed with Faith and Craig — SimplePractice cannot gate its own
// prescreener, so the website is the only place left to act).
//
// Call sites keep using the same openSimplePractice*() helpers. Each one now
// asks the mounted <SimplePracticeGate /> to run the challenge and, once the
// backend hands back a link, sends the visitor there.

// Client Portal is a sign-in link for existing clients, not a booking form, so
// it stays a plain link — challenging returning clients on every visit buys
// nothing, and the abuse is on the appointment-request flow.
export const SIMPLEPRACTICE_CLIENT_PORTAL_URL =
  'https://account.simplepractice.com/saml/auth?SAMLRequest=fVJdj9MwEPwrefNTml6OtIrVVCqtEJUOiNrAw72cts4eZymxjXfDlX%2BP3Q8I0tEnS96Z8cx4FwR95%2BRq4Bezwx8DEicrIvSsrVlbQ0OPfo%2F%2Bp1b4dfdQiRdmRzLLCNXgcUK6dx06D4oDYqJsnw2BTVnUzSDIimQTRLWBqPiXD0rZwfBbAiPqdlOJJzUvDvfFFNJ5O7tL37U5puW8LFJVAsD9AaEs8wAlGnBriMFwJfJpPkunszQvmruZLAqZl48iqb1lq2z3XptWm%2B%2BVGLyRFkiTNNAjSVZyv%2Fr0IPPJVB7OIJIfm6ZO6y%2F7RiTfQrRTjAAQybHvDMlo97YSXAsdU9xtjrtYFctFRMtTPL%2F8t64UnFtk4%2Fni%2FJ%2Bfg952U9tOq1%2FJquvs69ojMFaC%2FYAi%2BWB9D3zbQbzRbfp8gkr2YEijYZFdH7nsC7an7QnLwnjkZG17B15TbAmPwec1wRi17kInO3xe3qxNSRVx4boOx6v1bfxAVOHJJtpx1vMl%2Fpvi59l%2FjP6Zjnd%2F%2BRs%3D';

// The gate registers itself here on mount. Keeping the reference in a module
// variable is what lets every existing call site stay a plain function call
// instead of having to become a hook.
let gate = null;

export const registerSimplePracticeGate = (handler) => {
  gate = handler;
};

export const unregisterSimplePracticeGate = (handler) => {
  if (gate === handler) gate = null;
};

// With no gate mounted there is nothing to verify against, and opening the link
// anyway would be exactly the bypass we are closing — so this fails loudly
// rather than quietly.
const requestLink = (payload) => {
  if (!gate) {
    console.error('[simplePractice] gate is not mounted — booking request ignored');
    return;
  }
  gate(payload);
};

export const openSimplePracticeConsultation = () => requestLink({ type: 'consultation' });

export const openSimplePracticeContact = () => requestLink({ type: 'contact' });

// Opens a specific practitioner's booking flow. The name is resolved to a
// clinician id on the backend, so an unknown name comes back as "no link".
export const openSimplePracticeBooking = (practitionerName) =>
  requestLink({ type: 'practitioner', practitioner: practitionerName });

export const openSimplePracticeClientPortal = () => {
  window.open(SIMPLEPRACTICE_CLIENT_PORTAL_URL, '_blank', 'noopener,noreferrer');
};
